function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 0.760784 0 0 0 0 0.878431 0 0 0 0 0.862745 0 0 0 1.000000 0"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "High-Fi-",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "REJ4---Krok2-Brak-Innych-Numero\\u0301w",
  transform: "translate(-175.000000, -108.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "My_Account",
  transform: "translate(175.000000, 108.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic_account_circle",
  fill: "#C2E0DC",
  fillOpacity: 0.28
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-24px"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32,0.556311413 C14.6430839,0.556311413 0.556311413,14.6430839 0.556311413,32 C0.556311413,49.3569161 14.6430839,63.4436886 32,63.4436886 C49.3569161,63.4436886 63.4436886,49.3569161 63.4436886,32 C63.4436886,14.6430839 49.3569161,0.556311413 32,0.556311413 L32,0.556311413 Z",
  id: "Path"
}))), /*#__PURE__*/React.createElement("g", {
  id: "to-delete",
  transform: "translate(11.000000, 7.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Safespace",
  x: 0,
  y: 0,
  width: 44,
  height: 44
}), /*#__PURE__*/React.createElement("g", {
  id: "moje_konto",
  transform: "translate(2.200000, 1.650000)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter-1)",
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.854286, 0.256905)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.6142857,18.5145594 C21.360773,18.5249304 24.7441471,16.2761102 26.1850825,12.8177897 C27.6260179,9.35946934 26.8403758,5.37359688 24.1948862,2.72073816 C21.5493965,0.0678794362 17.5657248,-0.728846862 14.1034096,0.702463208 C10.6410945,2.13377328 8.38285714,5.51087889 8.38285714,9.25738059 C8.38285714,14.3599342 12.5117518,18.5003497 17.6142857,18.5145594 L17.6142857,18.5145594 Z",
  id: "Path",
  fill: "#47A9A0",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.3714286,21.3430949 L12.8571429,21.3430949 C5.75633893,21.3430949 1.17239551e-14,27.0994338 1.17239551e-14,34.2002377 C1.17239551e-14,34.9103181 0.575633893,35.485952 1.28571429,35.485952 L34.0457143,35.485952 C34.7557947,35.485952 35.3314286,34.9103181 35.3314286,34.2002377 C35.3314286,30.7724152 33.9628401,27.4864659 31.5293661,25.0723052 C29.0958922,22.6581446 25.7991414,21.3156723 22.3714286,21.3430949 Z",
  id: "Path",
  fill: "#47A9A0",
  fillRule: "nonzero"
}))), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#47A9A0",
  fillRule: "nonzero",
  cx: 18.2828571,
  cy: 13.3971429,
  r: 9.23142857
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.7142857,39.96 L1.8,39.96 C1.08991961,39.96 0.514285714,39.3843661 0.514285714,38.6742857 C0.514285714,31.5523854 6.24987738,25.7590853 13.3714286,25.6885714 L22.8857143,25.6885714 C30.0072655,25.7590853 35.7431218,31.5523854 35.7431218,38.6742857 C35.7553745,39.2949781 35.322587,39.8359625 34.7142857,39.96 Z M3.21428571,37.3885714 L33.3514286,37.3885714 C32.7600183,32.1640171 28.3235295,28.2266333 23.0657143,28.26 L13.5257143,28.26 C8.28007478,28.271681 3.86188413,32.1830468 3.21428571,37.3885714 Z",
  id: "Shape",
  fill: "#5B5B5B"
}))))));

var SvgMyAccSummary = function SvgMyAccSummary(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMyAccSummary, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MyAccSummary.c4060292.svg";
export { ForwardRef as ReactComponent };